<template>
    <app-content-admin>
        <template slot="header">Ad</template>
        <template>
            <v-row align="center">
                <v-col cols="10">
                    <v-text-field
                        v-model="searchTerm"
                        label="Ads Name"
                        outlined
                        clearable
                        solo-inverted
                        full-width
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="adListData" class="ma-2">Search</v-btn>
                </v-col>
            </v-row>
        </template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="primary"
                to="/ad/add_ad"
            >
                + Add Ad
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">Id</th>
                            <th scope="col">Name</th>
                            <!-- <th scope="col">Link Url</th> -->
                            <th scope="col">Active</th>
                            <!-- <th scope="col">Image Link</th> -->
                            <th scope="col">Start Date</th>
                            <th scope="col">End Date</th>
                            <th scope="col">Action</th>
                            <th scope="col">Placement Names</th>
                        </thead>

                        <tbody>
                            <tr
                                class="text-center"
                                v-for="(ads, i) in displayedItems"
                                :key="i"
                            >
                                <td :data-label="$t('Id')">
                                    {{ ads.ad.ad_id }}
                                </td>
                                <td
                                    :data-label="$t('Name')"
                                    class="text-truncate"
                                >
                                    {{ ads.ad.ad_name }}
                                </td>
                                <!-- <td
                                    :data-label="$t('Link Url')"
                                    class="text-truncate"
                                >
                                    {{ ads.ad.ad_link_url }}
                                </td> -->
                                <td :data-label="$t('Active')">
                                    <v-switch
                                        v-model="ads.ad.ad_active"
                                        :disabled="true"
                                    ></v-switch>
                                </td>
                                <!-- <td
                                    :data-label="$t('Image Url')"
                                    class="text-truncate"
                                >
                                    {{ ads.ad.ad_image_url }}
                                </td> -->
                                <td :data-label="$t('Start Date')">
                                    <input
                                        type="datetime-local"
                                        v-model="ads.ad.ad_start_date"
                                        :disabled="true"
                                    />
                                </td>
                                <td :data-label="$t('End Date')">
                                    <input
                                        type="datetime-local"
                                        v-model="ads.ad.ad_end_date"
                                        :disabled="true"
                                    />
                                </td>

                                <td :data-label="$t('action')">
                                    <v-menu
                                        :close-on-content-click="true"
                                        :nudge-width="200"
                                        :open-on-click="true"
                                        offset-y
                                        offset-x
                                        left
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="primary"
                                                text
                                                small
                                                icon
                                                v-on="on"
                                            >
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                @click="
                                                    ViewAdDetail(ads.ad.ad_id)
                                                "
                                            >
                                                <v-list-item-action>
                                                    Edit
                                                </v-list-item-action>
                                            </v-list-item>
                                            <v-list-item
                                                @click="
                                                    selectAdToDelete(
                                                        ads.ad.ad_id
                                                    )
                                                "
                                                v-if="isRole == 'admin'"
                                            >
                                                <v-list-item-action>
                                                    Delete
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>

                                <td :data-label="$t('Placement Name')">
                                    <div
                                        v-if="
                                            ads.relatedZoneNames &&
                                            ads.relatedZoneNames.length > 0
                                        "
                                    >
                                        {{
                                            showZoneNames[ads.ad.ad_id]
                                                ? ads.relatedZoneNames.join(
                                                      ", "
                                                  )
                                                : ads.relatedZoneNames
                                                      .slice(0, 3)
                                                      .join(", ")
                                        }}
                                        <span
                                            v-if="
                                                ads.relatedZoneNames.length > 3
                                            "
                                            @click="
                                                toggleShowZoneNames(
                                                    ads.ad.ad_id
                                                )
                                            "
                                            style="cursor: pointer; color: blue"
                                        >
                                          
                                            {{
                                                showZoneNames[ads.ad.ad_id]
                                                    ? $t("Less")
                                                    : $t("More")
                                            }}
                                        </span>
                                    </div>
                                    <div v-else>No Zones</div>
                                </td>
                                <tr
                                @click="
                                                toggleShowZoneNames(
                                                    ads.ad.ad_id
                                                )
                                            "
                                v-if="isPlacementExpand">
                                    {{
                                                showZoneNames[ads.ad.ad_id]
                                                    ? $t("Less")
                                                    : $t("More")
                                            }}
                                </tr>
                                
                                
                            </tr>




                            
                        </tbody>
                    </table>
                    <!-- Confirmation Dialog -->
                    <v-dialog v-model="showConfirmationDialog" max-width="400">
                        <v-card>
                            <v-card-title>Confirm Deletion</v-card-title>
                            <v-card-text>
                                Are you sure you want to delete this ad?
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    color="primary"
                                    @click="deleteAd(adToDelete)"
                                >
                                    Yes
                                </v-btn>
                                <v-btn @click="cancelDelete">No</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
                <v-pagination
                    class="pagination mb-2"
                    v-model="currentPage"
                    :length="totalPages"
                    @input="updatePage"
                    :total-visible="7"
                ></v-pagination>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            ads: [],
            form: {
                page: 1,
                offset: 10,
            },
            itemsPerPage: 10,
            currentPage: 1,
            showDialog: false,
            showConfirmationDialog: false, // Initialize to false
            adToDelete: null, // Store the selected user for deletion
            isRole: null,
            searchTerm: "",
            searchResult: [],
            showZoneNames: {},
        };
    },

    components: { ActiveLabel },

    computed: {
        totalPages() {
            return Math.ceil(this.ads.length / this.itemsPerPage);
        },
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            console.log(endIndex);
            return this.ads.slice(startIndex, endIndex);
        },
    },

    created() {
        this.adListData();
        this.isRole = this.$store.getters["auth/role"];
    },

    methods: {
        //Pagination
        updatePage(page) {
            this.currentPage = page;
        },

        onListChange(page) {
            this.adListData(10, page);
        },

        //Read all ad data
        adListData() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_ad_list`, {
                    params: {
                        search_term: this.searchTerm,
                    },
                })

                .then((res) => res.data)
                .then((res) => {
                    this.ads = res.result.map((item) => {
                        return {
                            ad: item.ad,
                            relatedZoneNames: item.placements.map(
                                (placement) => placement.placement_name
                            ),
                        };
                    });
                })

                .catch((e) => {
                    this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

        //Delete Ad specific data
        async deleteAd(id) {
            let loader = this.$loading.show();

            try {
                let res = await axios.post(`/api/auth/delete_ad`, {
                    ads_id: id,
                });

                // Log the response for debugging
                console.log("Delete Ad API Response:", res);

                if (res.data) {
                    this.$toastr.s("Delete successfully");
                    this.cancelDelete();
                    this.$router.push({ path: "/ad" });
                }
            } catch (e) {
                console.error("Error deleting ad:", e);

                this.$toastr.e(e.message);
            } finally {
                loader.hide();
                this.adListData();
            }
        },

        //Edit Route
        ViewAdDetail(id) {
            console.log("Current ad id:", id);
            this.$router.push({ path: "/ad/view_ad/" + id });
        },

        //Delete dialog function
        selectAdToDelete(id) {
            // Store the user data to delete
            this.adToDelete = id;

            // Open the confirmation dialog
            this.showConfirmationDialog = true;
        },
        cancelDelete() {
            // Reset the data and close the confirmation dialog
            this.showConfirmationDialog = false;
            this.adToDelete = null;
        },

        // more or less placement names dropdown control for specific ad
        toggleShowZoneNames(adId) {
            this.$set(this.showZoneNames, adId, !this.showZoneNames[adId]);
        },
    },
};
</script>
